document.addEventListener('DOMContentLoaded', function() {
    const blocks = document.querySelectorAll('.pulse-container');

    blocks.forEach(el => {
        const isMobile = window.innerWidth <= 768;

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;

                if (isMobile) {
                    // Mobile: delay 2 seconds, then auto-swap
                    setTimeout(() => {
                        const defaultImg = entry.target.querySelector('.image-default');
                        const hoverImg = entry.target.querySelector('.image-hover');

                        if (defaultImg && hoverImg) {
                            defaultImg.style.opacity = 0;
                            hoverImg.style.opacity = 1;
                        }
                    }, 2000);

                } else {
                    // Desktop: pulse animation
                    entry.target.classList.add('pulse');

                    // Stop pulse on hover
                    entry.target.addEventListener('mouseenter', () => {
                        entry.target.classList.remove('pulse');
                    });
                }

                observer.unobserve(entry.target); // run once
            });
        }, {
            rootMargin: isMobile ? '-100px 0px 0px 0px' : '0px',
            threshold: 0
        });

        observer.observe(el);
    });
});